import { Constant } from "../../constant"

const { CHECK_SELECTED_LANG } = Constant

export const getValueByLanguage = (
  value1: number | string,
  value2: number | string,
) => (CHECK_SELECTED_LANG ? value1 : value2)
